<template>
  <div>
    <template v-if="!selectedSession">
      <p>Selecione o caixa aberto onde a compra será lançada.</p>
      <q-select
        label="Caixa aberto"
        :model-value="selectedSession"
        :options="sessions"
        :option-label="sessionLabel"
        :loading="loading"
        :disable="loading || Boolean(error)"
        @update:model-value="selectedSession = $event"
      />
      <p v-if="!loading && !error && !sessions.length" role="status">
        Nenhum caixa aberto disponível. Abra um caixa com sua permissão habitual antes de importar.
      </p>
      <p v-if="error" class="text-negative" role="alert">{{ error }}</p>
      <q-btn v-if="error" flat label="Tentar novamente" @click="loadSessions" />
      <q-btn v-else-if="nextPage" flat label="Carregar mais caixas" :loading="loading" @click="loadSessions" />
    </template>
    <template v-else>
      <p class="text-weight-medium">{{ sessionLabel(selectedSession) }}</p>
      <revisao-captura-boloes-foto
        :movcaixa-id="selectedSession.id"
        :arquivo-inicial="arquivoInicial"
        reaproveitar-compra-do-caixa
      />
    </template>
  </div>
</template>

<script>
import axios from '@/axios-auth';
import RevisaoCapturaBoloesFoto from '@/components/Caixas/boloes-foto/revisao-captura.vue';

export default {
  name: 'stock-photo-import',
  components: { RevisaoCapturaBoloesFoto },
  props: {
    arquivoInicial: {
      type: File,
      default: null,
    },
  },
  data() {
    return {
      sessions: [],
      selectedSession: null,
      loading: false,
      error: '',
      page: 0,
      nextPage: true,
    };
  },
  computed: {
    sessionIdentity() {
      const getters = this.$store.getters;
      return `${(getters.dataEmpresa || {}).id}:${(getters.dataUser || {}).id}`;
    },
  },
  watch: {
    sessionIdentity() {
      this.sessions = [];
      this.selectedSession = null;
      this.page = 0;
      this.nextPage = true;
      this.loading = false;
      this.loadProducts();
      this.loadSessions();
    },
  },
  mounted() {
    this.loadProducts();
    this.loadSessions();
  },
  methods: {
    loadProducts() {
      this.$store.dispatch('produtosEstoque', { tipo: 'P', all: 1, ativo: 1 });
    },
    sessionLabel(session) {
      return `${session.caixa_nome} - Sessão ${session.sessao} - ${session.func_resp_nome}`;
    },
    async loadSessions() {
      if (this.loading) return;
      const identity = this.sessionIdentity;
      this.loading = true;
      this.error = '';
      try {
        const response = await axios.get('/lancamentos/caixas', { params: { status: 'A', page: this.page + 1 } });
        if (identity !== this.sessionIdentity) return;
        if (response.error) throw response.error;
        if (!response.data || !response.data.success) {
          throw new Error('Não foi possível carregar os caixas abertos. Verifique seu acesso e tente novamente.');
        }
        this.sessions = this.sessions.concat(response.data.movcaixas.filter(session => session.status === 'A'));
        this.page += 1;
        this.nextPage = Boolean(response.data.paging && response.data.paging.nextPage);
        if (this.arquivoInicial && !this.nextPage && this.sessions.length === 1) this.selectedSession = this.sessions[0];
      } catch (error) {
        if (identity !== this.sessionIdentity) return;
        this.error = 'Não foi possível carregar os caixas abertos. Verifique sua licença e permissão e tente novamente.';
      } finally {
        if (identity === this.sessionIdentity) this.loading = false;
      }
    },
  },
};
</script>
